import lazyload from '@/lazyload';

export default () => {
  $('.copy-link').on('click', function () {
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = $(this).attr('data-href');
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style = {position: 'absolute', left: '-9999px'};
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);

    $(this).addClass('copied');
    $(this).find("span").html("¡Enlace copiado!");
  });

  $('.cmp-last-posts button').on('click', function () {
    $.ajax({
      url: $(this).attr('data-href')
    }).done(function (response) {
      $('.minute-by-minute .items').append(response.html);

      lazyload.update();
      if (response.nextPage) {
        console.log(response);
        $('.minute-by-minute button').attr('data-href', response.nextPage);
      } else {
        $('.minute-by-minute button').hide();
      }
    })
  });

  if ($(".cmp-last-posts").length) {
    setInterval(function(){
      $.ajax({
        url: $('.cmp-last-posts').attr('data-href')
      })
        .done(function (response) {
          if (response.newData) {
            $('.cmp-last-posts').attr('data-href', response.nextPage)
                                .find('.items').prepend(response.html);
            lazyload.update();
            // window.FB.XFBML.parse();
            // window.instgrm.Embeds.process();
          } else {
            $('.cmp-last-posts').attr('data-href', response.nextPage);
          }
        });
    }, 30000);
  }
}
